<template>
  <div
    class="main--text">
    <Loading
      v-if="isLoading"/>
    <v-row
      no-gutters
      v-else
      justify=center
      >
        <v-col
          cols=12
          md=8
          sm=8
          v-if="inOffers.length()"
          >
          <v-card
            width=800>
            <v-container
              fluid>
              <v-row
                no-gutters>
                <v-col>
                  <h3>{{inOffers.length()}}件の授業を依頼中です。</h3>
                </v-col>
              </v-row>
              <template
                v-for="(offer, index) in inOffers.get()">
                <v-offer-from-parent
                  :key="offer.id"
                  :offer="offer"/>
                <v-row
                  :key="index"
                  justify=end>
                  <v-col
                    cols=auto
                    class="no--vertical--paddings">
                    <v-btn
                      rounded
                      outlined
                      @click="withdraw(offer)">
                      取り下げる
                    </v-btn>
                  </v-col>
                </v-row>
              </template>
            </v-container>
          </v-card>
        </v-col>
        <v-col
          cols=12
          md=8
          sm=8
          v-if="agreeds.length()">
          <v-card
            width=800>
            <v-container
              fluid>
              <v-row
                no-gutters>
                <v-col>
                  <h3>{{agreeds.length()}}件の授業が確定しました。</h3>
                </v-col>
              </v-row>
              <template
                v-for="(offer, index) in agreeds.get()">
                <v-offer-from-parent
                  :key="offer.id"
                  :offer="offer"/>
                <v-row
                  :key="index"
                  justify=end>
                  <v-col
                    cols=auto
                    class="no--vertical--paddings">
                    <v-btn
                      rounded
                      outlined
                      @click="confirm(offer)">
                      OK
                    </v-btn>
                  </v-col>
                </v-row>
              </template>
            </v-container>
          </v-card>
        </v-col>
        <v-col
          cols=12
          md=8
          sm=8
          v-if="disagreeds.length()">
          <v-card
            width=800>
            <v-container
              fluid>
              <v-row
                no-gutters>
                <v-col>
                  <h3>{{disagreeds.length()}}件の授業が受理されませんでした。</h3>
                </v-col>
              </v-row>
              <template
                v-for="(offer, index) in disagreeds.get()">
                <v-offer-from-parent
                  :key="offer.id"
                  :offer="offer"/>
                <v-row
                  :key="index"
                  justify=end
                  no-gutters>
                  <v-col
                    cols=auto
                    class="no--vertical--paddings">
                    <v-btn
                      depressed
                      rounded
                      outlined
                      @click="disposal(offer)">
                      削除
                    </v-btn>
                  </v-col>
                </v-row>
              </template>
            </v-container>
          </v-card>
        </v-col>
        <v-col
          v-if="!offers.length()"
          cols=12
          md=8
          sm=8>
          <v-card>
            <v-container>
              <v-row>
                <v-col>
                  あなたが応募している案件はありません
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
    </v-row>
  </div>
</template>

<script>
import { firestore } from "@/repository/client/firestore"
import { LessonOfferRepository } from "@/repository/LessonOfferRepository"
import VOfferFromParent from "@/components/organisms/parent/VOfferFromParent.vue"
import Loading from "@/components/organisms/Loading.vue"

export default {
  components: {
    VOfferFromParent,
    Loading
  },
  data () {
    return {
      lessonRepo: null,
      agreeds: null,
      inOffers: null,
      disagreeds: null,
      isLoading: true
    }
  },
  methods: {
    async withdraw(offer) {
      const result = this.lessonRepo.delete(offer)
      this.inOffers.remove(offer.id)
    },
    async confirm(offer) {
      const result = this.lessonRepo.delete(offer)
      this.agreeds.remove(offer.id)
    },
    async disposal(offer) {
      const result = this.lessonRepo.delete(offer)
      this.disagreeds.remove(offer.id)
    }
  },
  created: async function () {
    this.lessonRepo = new LessonOfferRepository(firestore)
    this.offers = await this.lessonRepo.listOfAllOffers(this.$store.getters.parent.uuid)
    this.inOffers = this.offers.inOffers()
    this.agreeds = this.offers.agreeds()
    this.disagreeds = this.offers.disagreeds()
    this.isLoading = false
  }
}
</script>

<style scoped>
.no--vertical--paddings {
  padding: 0px 12px;
}
</style>
